import apiHandler from "../core/apiHandler";

const cashClosureApi = apiHandler("cash/closures");

export default cashClosureApi;